import classNames from 'classnames';
import Typography from 'components/generics/texts/Typography';
import { HTMLAttributes, PropsWithChildren } from 'react';
import classes from './index.module.scss';

interface Props extends PropsWithChildren, HTMLAttributes<HTMLDivElement> {
  title?: string;
  subtitle?: string;
  titleClassName?: string;
  subtitleClassName?: string;
  withBottomLine?: boolean;
  titlesClassName?: string;
}

const ProfileSection = ({
  title,
  subtitle,
  withBottomLine,
  children,
  titleClassName,
  subtitleClassName,
  titlesClassName,
  className,
}: Props) => {
  return (
    <div
      className={classNames(
        classes.container,
        className,
        withBottomLine && classes.bottomLine
      )}
    >
      <div className={classNames(classes.topContainer, titlesClassName)}>
        {title && (
          <Typography className={classNames(classes.title, titleClassName)}>
            {title}
          </Typography>
        )}
        {subtitle && (
          <Typography
            className={classNames(classes.subtitle, subtitleClassName)}
          >
            {subtitle}
          </Typography>
        )}
      </div>
      {children}
    </div>
  );
};

export default ProfileSection;
